import { useState } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import styled from 'styled-components';

import { SliderProductCard } from 'components/ui';
import { ArrowFilterIcon } from 'components/icons';
import { Subtitle3 } from '@components/styles/Typography';

const ProductSlider = ({
    icon,
    background,
    withDots,
    products,
    title,
    productDetailSlide,
    name,
}) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const [sliderRef, instanceRef] = useKeenSlider({
        initial: currentSlide,
        centered: true,
        mode: 'snap',
        loop: true,
        slides: {
            perView: 6,
            spacing: 10,
        },

        breakpoints: {
            '(max-width: 1024px)': {
                slides: {
                    perView: 1.9,
                    spacing: 30,
                },
            },
            '(max-width: 768px)': {
                slides: {
                    perView: 1.9,
                    spacing: 30,
                },
            },
        },
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        created() {
            setLoaded(true);
        },
    });

    return (
        <SliderWrapper
            backgroundColor={background}
            title={title}
            productDetailSlide={productDetailSlide}
            data-testid="product-slider"
        >
            <Header>
                <TitleWrapper>
                    <Subtitle3>{title}</Subtitle3>
                </TitleWrapper>
                {icon && icon}
            </Header>
            <Slider
                ref={sliderRef}
                className={`keen-slider ${name}`}
                id={name}
                name={name}
            >
                {products?.map((product) => (
                    <SliderProductCard
                        key={product.id}
                        type={name}
                        product={name === 'favorites' ? product.model : product}
                    />
                ))}
            </Slider>
            {loaded && instanceRef.current && (
                <SliderArrowContainer>
                    <ArrowFilterIcon
                        onClick={(e) =>
                            e.stopPropagation() || instanceRef.current.prev()
                        }
                        disabled={currentSlide === 0}
                        style={{
                            width: '18px',
                            height: '30px',
                            position: 'absolute',
                            right: '96%',
                            top: '50%',
                            transform: 'rotate(180deg)',
                            opacity: '0.3',
                            cursor: 'pointer',
                        }}
                    />
                    <ArrowFilterIcon
                        onClick={(e) =>
                            e.stopPropagation() || instanceRef.current.next()
                        }
                        // disabled={
                        //     currentSlide ===
                        //     instanceRef.current.track.details.slides.length - 1
                        // }
                        style={{
                            width: '18px',
                            height: '30px',
                            position: 'absolute',
                            right: '3%',
                            top: '50%',
                            opacity: '0.3',
                            cursor: 'pointer',
                        }}
                    />
                </SliderArrowContainer>
            )}
            {loaded && instanceRef.current && withDots && (
                <Dots>
                    {[
                        ...Array(
                            instanceRef.current.track.details.slides.length,
                        ).keys(),
                    ].map((idx) => (
                        <Dot
                            key={idx}
                            onClick={() => {
                                instanceRef.current?.moveToIdx(idx);
                            }}
                            isActive={currentSlide === idx}
                            aria-label={`dot-${idx}`}
                        />
                    ))}
                </Dots>
            )}
        </SliderWrapper>
    );
};
const SliderWrapper = styled.div`
    position: relative;
    background-color: ${({ backgroundColor }) => backgroundColor};
    width: 100vw;
    padding: 20px 87px;
    margin: 40px 0;

    @media (max-width: 768px) {
        padding: 0;
        margin: 10px 0;
    }
`;
const Slider = styled.div`
    margin-top: 20px;
    padding: 0 3px;
    @media (max-width: 768px) {
        padding: 0 15px;
    }
`;
const Header = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
`;
const TitleWrapper = styled.div`
    position: relative;
    margin: 0;

    :before {
        position: absolute;
        content: '';
        width: 80px;
        height: 0.5px;
        background-color: black;
        bottom: -8px;
    }

    @media (max-width: 768px) {
        padding-left: 20px;
    }
`;
const Dots = styled.div`
    display: flex;
    padding: 30px 0 10px;
    justify-content: center;
    overflow: auto;

    ::-webkit-scrollbar {
        display: none;
    }
`;
const Dot = styled.button`
    border: none;
    width: 8px;
    height: 8px;
    background: ${({ isActive }) => (isActive ? 'black' : '#c5c5c5')};
    border-radius: 50%;
    margin: 0 5px;
    padding: 5px;
    cursor: pointer;
    position: relative;

    ::after {
        content: '';
        position: absolute;
        top: -4px;
        left: -4px;
        width: 16px;
        height: 16px;
        border: ${({ isActive, theme }) =>
            isActive ? `1px solid ${theme.colors.bgGray50}` : '#c5c5c5'};
        border-radius: 50px;
    }
`;

const SliderArrowContainer = styled.div`
    @media (max-width: 1024px) {
        display: none;
    }
`;
export default ProductSlider;
